import { useMemo } from "react";
import { localeForLanguage } from "./language.js";
import { useSettingsStore } from "../stores/settings.store.js";

export function useAppLocale(): string {
  const language = useSettingsStore((s) => s.language);
  return useMemo(() => localeForLanguage(language), [language]);
}
